export interface CategoryInfo {
  key: string;
  label: string;
  icon: string;
  description: string;
  color: string;
}

export const categories: CategoryInfo[] = [
  {
    key: 'movie',
    label: '电影',
    icon: 'ri-film-line',
    description: '超清大片随心看',
    color: 'primary',
  },
  {
    key: 'tv',
    label: '电视剧',
    icon: 'ri-tv-line',
    description: '热播剧集追不停',
    color: 'accent',
  },
  {
    key: 'anime',
    label: '动漫',
    icon: 'ri-emotion-line',
    description: '国漫日漫全收录',
    color: 'secondary',
  },
  {
    key: 'variety',
    label: '综艺',
    icon: 'ri-live-line',
    description: '爆笑综艺乐翻天',
    color: 'secondary',
  },
];